import { vars } from 'src/core/themes';

export const shimmerHeight = vars.spacing.xl;
